import axios from 'axios';
import authHeader from "./auth-header";
//import authHeader from "./auth-header";

class PublisherService {
    getPublishers() {
        return axios.get(window.api_url + "/api/publishers");
    }

    getPublisher(id){
        return axios.get(window.api_url + "/api/auth/publisher/" + id + "/show",  { headers: authHeader() });
    }

    addPublisher(name) {
        let formData = new FormData();
        formData.append('name', name);
        return axios.post(window.api_url + "/api/auth/publisher", formData, { headers: authHeader() });
    }

    updatePublisher(id, name){
        let formData = new FormData();
        formData.append('name', name);
        return axios.post(window.api_url + "/api/auth/publisher/" + id, formData, { headers: authHeader() });
    }

    deletePublisher(id){
        return axios.delete(window.api_url + "/api/auth/publisher/" + id,  { headers: authHeader() });
    }

}

export default new PublisherService();